<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 16:13:54
 * @FilePath: /privacy-web/src/views/PrivacyProtect/ManageSystem.vue
-->
<template>
  <div class="Manage-system-main" :class="{ 'Manage-system-main-mobile': isMobile }">
    <div class="center">
      <Base-title title="科学管理 双向驱动"></Base-title>
      <Manage-system-content></Manage-system-content>
    </div>
  </div>
</template>
<script>
export default {
  // 管理体系
  name: "ManageSystem",
};
</script>
<style lang="scss" scoped>
.Manage-system-main {
  /* background: #f6faff; */
  .center {
    width: auto;
    height: calc($multiple * 781px);
    position: relative;
    display: flex;
    align-items: center;
    padding-top: calc($multiple * 78px);
    flex-direction: column;
  }
}
.Manage-system-main-mobile {
  /* background: #f6faff; */
  .center {
    width: auto;
    margin: auto;
    position: relative;
    display: flex;
    align-items: center;
    padding-top: 2.4rem;
    // height: 40rem;
    flex-direction: column;
  }
}
</style>
